"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_components_1 = require("@as-react/common-components");
const common_types_1 = require("@as-react/common-types");
const react_1 = require("react");
const ConfigurationUtil_1 = require("../../../util/ConfigurationUtil");
const DpeVitality_1 = require("../dpe-vitality/DpeVitality");
const DpeValidator = ({ digitalPartner, onValidationError, onValidationSuccess, }) => {
    const aemConfiguration = (0, react_1.useContext)(common_components_1.AemConfigurationContext);
    const dpeApiConfig = (0, ConfigurationUtil_1.getDpeApiConfig)(aemConfiguration);
    const renderPartner = () => {
        switch (digitalPartner) {
            case common_types_1.DpePartner.VITALITY:
                return ((0, jsx_runtime_1.jsx)(DpeVitality_1.default, { apiConfig: dpeApiConfig, onValidationSuccess: onValidationSuccess, onValidationError: onValidationError }));
            default:
                return null;
        }
    };
    return renderPartner();
};
exports.default = DpeValidator;
